import { BaseDto } from 'src/dtos/common/baseDto';

/** 사원별 외출·복귀 기록과 그리드 편집 상태이다. */
export interface HrmAttendEventDto extends BaseDto {
    empNo: string; // 사원번호
    workDt: string; // 근무일자
    eventSeq: number; // 업무 발생순번
    attendCd: string; // 외출·공용외출·복귀 코드
    eventTime: string; // 발생 시각
    remark: string; // 사유
    inserted: boolean; // 신규 행이면 true
    isModified: boolean; // 편집된 행이면 true
}

/** 신규 외출·복귀 기록의 기본값이다. */
export const defaultHrmAttendEventDto: HrmAttendEventDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    empNo: '', workDt: '', eventSeq: 0, attendCd: '', eventTime: '',
    remark: '', inserted: false, isModified: false,
};
